import AddIcon from "@mui/icons-material/AddCircle";
import Divider from "@mui/material/Divider";
import Grow from "@mui/material/Grow";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Grid from "@mui/material/Unstable_Grid2";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TransitionGroup } from "react-transition-group";
import { selectCanEditCustomersWithGds } from "../redux/auth";
import { deleteGdsOffice, selectGdsOfficesByCustomerId } from "../redux/gds";
import EditGdsId from "./EditGdsId";
import GdsId from "./GdsId";

const CustomerGdsIds = (props) => {
  const dispatch = useDispatch();

  const canEdit = useSelector(selectCanEditCustomersWithGds);

  const gdsOffices = useSelector((state) =>
    selectGdsOfficesByCustomerId(state, props.customerId),
  );

  const [showEditGdsId, setShowEditGdsId] = useState(false);
  const [showAddButton, setShowAddButton] = useState(true);

  const onAddGdsOffice = () => {
    setShowAddButton(false);
  };

  const onCloseEdit = () => {
    setShowEditGdsId(false);
  };

  const onConfirmRemove = (gdsOffice) => {
    return dispatch(deleteGdsOffice(gdsOffice));
  };

  return (
    <Grid
      container
      spacing={2}
      className={props.className}
      sx={{ overflowX: "hidden" }}
    >
      <Grid xs={12}>
        <Divider textAlign="left">GDS IDs</Divider>
      </Grid>
      <TransitionGroup component={null}>
        {gdsOffices.map((gdsOffice, index) => (
          <Collapse key={gdsOffice.id} component={Grid}>
            <GdsId
              disabled={!canEdit}
              gdsOffice={gdsOffice}
              onRemove={onConfirmRemove}
            />
          </Collapse>
        ))}
      </TransitionGroup>
      <Grid xs={12} textAlign="center">
        <Grow
          in={showEditGdsId}
          unmountOnExit
          onExited={() => setShowAddButton(true)}
        >
          <EditGdsId customerId={props.customerId} onClose={onCloseEdit} />
        </Grow>
        <Grow in={showAddButton} onExited={() => setShowEditGdsId(true)}>
          <IconButton
            disabled={!canEdit}
            disableRipple
            onClick={onAddGdsOffice}
          >
            <AddIcon />
          </IconButton>
        </Grow>
      </Grid>
    </Grid>
  );
};

export default CustomerGdsIds;
